export default {
    inject: ['container'],
    computed: {
        projeto () {
            return this.container.projeto
        }
    }
}
